import { Routes, Route, useNavigate } from "react-router-dom";
import { MsalProvider } from '@azure/msal-react';
import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux";
import { resetState } from "./redux/slices/userSlice";
import NotFound from "./pages/Error";
import Login from "./pages/Login";
import ModuleMonitoring from "./pages/mes/ModuleMonitoring";
import PlasticMonitoring from "./pages/mes/PlasticMonitoring";
import IpMonitoring from "./pages/mes/IpMonitoring";
import PbsCts from "./pages/mes/PbsCts";
import GAShipItem from "./pages/mes/GAShipItem";
import Main from "./pages/mesga/Main";
import MainSub from "./pages/mesga/MainSub";
import Menu from "./pages/Menu";
import RTMS from "./pages/mes/RTMS";
import ProductionMonitoring from "./pages/bsa1/ProductionMonitoring";
import KaGAMonitoring from "./pages/bsa1/KaGAMonitoring";
import KaGAMonitoringGA from "./pages/mesga/KaGAMonitoringGA";

function App({ instance }) {
  const userToken = useSelector((state) => state?.user?.token);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (userToken === "error") {
      dispatch(resetState());
      const account = instance.getActiveAccount();
      if (account) {
        const logoutRequest = {
          account: account,
          postLogoutRedirectUri: "/",
          mainWindowRedirectUri: "/",
        };
        instance.logoutRedirect(logoutRequest).catch((e) => {
          console.error('[Logout Error]', e);
          navigate("/");
        });
      } else {
        navigate("/");
      }
    }
  }, [userToken]);

  useEffect(() => {
    const setViewportScale = () => {
      const path = window.location.pathname;
      let scale;

      // URL에 따라 initial-scale 값을 설정
      if (path === '/mes/rtms' || path === '/rtms/rtmsall.jsp') {
        scale = '0.3';
      } else {
        scale = '1.0'; // 기본 값
      }

      // viewport meta 태그 찾아서 content 업데이트
      const viewportMeta = document.querySelector('meta[name="viewport"]');
      if (viewportMeta) {
        viewportMeta.setAttribute('content', `width=device-width, initial-scale=${scale}`);
      }
    };

    setViewportScale();

    // 경로가 변경될 때마다 viewport scale 재설정
    window.addEventListener('popstate', setViewportScale);

    // cleanup function
    return () => {
      window.removeEventListener('popstate', setViewportScale);
    };
  }, []);

  return (
    <MsalProvider instance={instance}>
      <Routes>
        <Route>
          <Route path="/" element={<Menu />} />
          <Route path="/mes" element={<Login />} />
          <Route path="/mesga" element={<Login />} />
          <Route path="/bsa1" element={<Login />} />
          <Route path="/kaga" element={<Login />} />
          <Route path="*" element={<NotFound />} />
        </Route>
        <Route>
          <Route exact path="/mes/module" element={<ModuleMonitoring />} />
          <Route exact path="/mes/plastic" element={<PlasticMonitoring />} />
          <Route exact path="/mes/ip" element={<IpMonitoring />} />
          <Route exact path="/mes/pbscts" element={<PbsCts />} />
          <Route exact path="/mes/gashipitem" element={<GAShipItem />} />
          <Route exact path="/mes/rtms" element={<RTMS />} />
          <Route exact path="/rtms/rtmsall.jsp" element={<RTMS />} />
          <Route exact path="/mesga/main" element={<Main />} />
          <Route exact path="/mesga/mainsub" element={<MainSub />} />
          <Route exact path="/mesga/kaga" element={<KaGAMonitoringGA />} />
          <Route exact path="/bsa1/production" element={<ProductionMonitoring />} />
          <Route exact path="/bsa1/kaga" element={<KaGAMonitoring />} />
        </Route>
      </Routes>
    </MsalProvider>
  );
}

export default App;